import AnchorAPI from '../AnchorAPI';

export default function initializeWithUser(user) {
  if (typeof mParticle === 'undefined') {
    return;
  }
  if (user && user.userId) {
    const userId = user.userId;
    AnchorAPI.getUserEmailAddress()
      .then(emailAddress => {
        if (emailAddress) {
          setUpIdentity({ emailAddress, userId });
          return;
        }
        setUpIdentity({ userId });
      })
      .catch(() => {
        setUpIdentity({ userId });
      });
  }
}

function setUpIdentity(userObject) {
  const loginRequestUserObject = {
    userIdentities: {},
  };
  if (userObject.userId) {
    // must be a string
    loginRequestUserObject.userIdentities.customerid = `${userObject.userId}`;
  }
  if (userObject.emailAddress) {
    loginRequestUserObject.userIdentities.email = userObject.emailAddress;
  }

  mParticle.Identity.login(loginRequestUserObject, onLoginResult);

  function onLoginResult(result) {
    if (result.httpCode == 429) {
      // in rare circumstances, requests will be throttled and need to be retried
      setUpIdentity(loginRequestUserObject);
    }
  }
}
